module.exports = __webpack_public_path__ + "static/offer-wireframe-flow-c0e386caa867d86c11385fdc6dac4531.svg";